import { cn } from "@/lib/utils";
import React from "react";

type TBadgeProps = {
  className?: string;
  children: React.ReactNode;
};

export const Badge = ({ className, children }: TBadgeProps) => (
  <span
    className={cn(
      "bg-secondary px-2 py-1 rounded-sm text-input text-lg",
      className
    )}
  >
    {children}
  </span>
);
